import Alpine from "alpinejs";

import "./app.css";

// import "flowbite";
import "flowbite/dist/flowbite.js";
// import { Dismiss } from 'flowbite';

// import "./datatable";
import "./calendar";
import "./chart";
import "./dark-mode";

import "./js/autocomplete";
import "./js/helper";
import "./js/po-items";
import "./js/table";

window.Alpine = Alpine;
Alpine.start();